import { cn } from 'src/shared/utils/cn'

import { MapMarkerIcon } from '../icons/map-marker-icon'

type BusinessMapMarkerProps = {
  name?: string
  size?: number
  className?: string
}

const BusinessMapMarker = ({ name, size = 70, className }: BusinessMapMarkerProps) => {
  return (
    <div className={cn('flex flex-col items-center gap-2', className)}>
      <MapMarkerIcon size={size} className="drop-shadow-[0_2px_12px_rgba(27,48,41,0.07)]" />
      {name && (
        <div className="rounded-full bg-white px-3 py-2 shadow-[0_2px_12px_rgba(27,48,41,0.07)]">
          <span className="max-w-[160px] truncate text-[11px] font-medium leading-[11px] text-primary">{name}</span>
        </div>
      )}
    </div>
  )
}

export default BusinessMapMarker
